// extracted by mini-css-extract-plugin
module.exports = {"favoriteButton":"MovieFavoriteToggle_favoriteButton__o2W6Z","active":"MovieFavoriteToggle_active__7KXb2","spinner":"MovieFavoriteToggle_spinner__O_Tzf"};